//
// 3rd-Party Plugins JavaScript Includes
//


//////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////
////  Mandatory Plugins Includes(do not remove or change order!)  ////
//////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////

// Jquery - jQuery is a popular and feature-rich JavaScript library. Learn more: https://jquery.com/
window.jQuery = window.$ = require('jquery');

// Bootstrap - The most popular framework uses as the foundation. Learn more: http://getbootstrap.com
window.bootstrap = require('bootstrap');

// Popper.js - Tooltip & Popover Positioning Engine used by Bootstrap. Learn more: https://popper.js.org
window.Popper = require('@popperjs/core');

// Wnumb - Number & Money formatting. Learn more: https://refreshless.com/wnumb/
window.wNumb = require('wnumb');

// Moment - Parse, validate, manipulate, and display dates and times in JavaScript. Learn more: https://momentjs.com/
window.moment = require('moment');

// ES6-Shim - ECMAScript 6 compatibility shims for legacy JS engines.  Learn more: https://github.com/paulmillr/es6-shim
require("es6-shim/es6-shim.min.js");

let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    window._token = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}
window.IpixJson = {};
window.IpixJson.lang = {};
window.IpixJson.options = {};

//////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////
///  Optional Plugins Includes(you can remove or add)  ///////////////
//////////////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////////////

// FormValidation - Best premium validation library for JavaScript. Zero dependencies. Learn more: https://formvalidation.io/
window.FormValidation = require('../../plugins/formvalidation/dist/js/FormValidation.full.min.js');
window.FormValidation.plugins.Bootstrap5 = require('../../plugins/formvalidation/dist/amd/plugins/Bootstrap5.js').default;
// window.FormValidation.plugins.Declarative = require('../../plugins/formvalidation/dist/amd/plugins/Declarative.js').default;
require('./plugins/FormValidation.init.js');

// Date Range Picker - A JavaScript component for choosing date ranges, dates and times: https://www.daterangepicker.com/
require('bootstrap-daterangepicker/daterangepicker.js');

// Bootstrap Maxlength - This plugin integrates by default with Twitter bootstrap using badges to display the maximum length of the field where the user is inserting text: https://github.com/mimo84/bootstrap-maxlength
require('bootstrap-maxlength/src/bootstrap-maxlength.js');

// Bootstrap Mmultiselectsplitter - Transforms a <select> containing one or more <optgroup> in two chained <select>: https://github.com/poolerMF/bootstrap-multiselectsplitter/
require('bootstrap-multiselectsplitter/bootstrap-multiselectsplitter.min.js');

// Select2 - Select2 is a jQuery based replacement for select boxes: https://select2.org/
require('select2/dist/js/select2.full.min.js');
require('./plugins/select2.init.js');

// msDropdown
require('../../plugins/msDropdown/js/index.js');
require('./plugins/ms-dropdown.init.js');

// Flatpickr - is a lightweight and powerful datetime picker.
require('flatpickr/dist/flatpickr.min.js');
require('./plugins/flatpickr.init.js');

// Inputmask - is a javascript library which creates an input mask: https://github.com/RobinHerbots/Inputmask
require('inputmask/dist/inputmask.js');
require('inputmask/dist/bindings/inputmask.binding.js');

// Toastr - is a Javascript library for non-blocking notifications. jQuery is required. The goal is to create a simple core library that can be customized and extended: https://github.com/CodeSeven/toastr
window.toastr = require('../../plugins/toastr/build/toastr.min.js');
require('./plugins/toastr.init.js');

// ES6 Promise Polyfill - This is a polyfill of the ES6 Promise: https://github.com/lahmatiy/es6-promise-polyfill
require('es6-promise-polyfill/promise.min.js');

require('owl.carousel2');
require('./plugins/owl.carousel2.init.js');

// Sweetalert2 - a beautiful, responsive, customizable and accessible (WAI-ARIA) replacement for JavaScript's popup boxes: https://sweetalert2.github.io/
window.Swal = window.swal = require('sweetalert2/dist/sweetalert2.min.js');
require('./plugins/sweetalert2.init.js');

require('../../plugins/locomotive/locomotive-scroll.js');

// A lightweight script to animate scrolling to anchor links
window.SmoothScroll = require('smooth-scroll/dist/smooth-scroll.js');

// Clipboard - Copy text to the clipboard shouldn't be hard. It shouldn't require dozens of steps to configure or hundreds of KBs to load: https://clipboardjs.com/
window.ClipboardJS = require('clipboard/dist/clipboard.min.js');

require('../../plugins/gsap/gsap.js');

// require('../../plugins/cursor/cursor.js');

// Ipixthemes' plugins
window.IpixComponents = require('./components/_init.js');
window.IpixUtil = require('./components/util.js');
window.IpixApp = require('./components/web.js');
window.IpixFormValidation = require('./components/formValidation.js');
window.IpixEnquiry = require('./components/enquiry.js');
window.IpixEventHandler = require('./components/event-handler.js');
window.IpixBlockUI = require('./components/blockui.js');
window.IpixFlatPicker = require('./components/flatPicker.js');
window.IpixCookie = require('./components/cookie.js');
window.IpixDialer = require('./components/dialer.js');
window.IpixDrawer = require('./components/drawer.js');
window.IpixImageInput = require('./components/image-input.js');
window.IpixMenu = require('./components/menu.js');
window.IpixForm = require('./components/form.js');
window.IpixModal = require('./components/modal.js');
window.IpixPasswordMeter = require('./components/password-meter.js');
window.IpixScroll = require('./components/scroll.js');
window.IpixScrolltop = require('./components/scrolltop.js');
window.IpixSticky = require('./components/sticky.js');
window.IpixSwapper = require('./components/swapper.js');
window.IpixToggle = require('./components/toggle.js');